export const STANDARD_TRIAL_PERIOD = 7
export const STANDARD_TRIAL_PERIOD_UNIT = 'day'
export const TYPE_PAY_AS_YOU_GO = 1
export const TYPE_PER_UNIT = 2
